
  import GlobalModals from '@/_legacy/components/Modals/GlobalModals.vue';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      GlobalModals,
    },
  });
